module.exports = __webpack_public_path__ + "static/media/HuntsmanHomeINTA0014_design_clean_v001.67afcd95.webp";